import React, { Fragment } from "react";
import PsychologistInitialAssessmentProvider from "../IpEMR/Psychologist/InitialInspection/PsychologistInitialAssessmentProvider";
import PsychologistInitialInspection from "../IpEMR/Psychologist/InitialInspection/PsychologistInitialInspection";
import PsychologistReviewProvider from "../IpEMR/Psychologist/Review/PsychologistReviewProvider";
import PsychologistReview from "../IpEMR/Psychologist/Review/PsychologistReview";
import MedicationHistoryIP from "./MedicationsIp/MedicationHistoryIP";
import ChatTabs from "./Chat/ChatTabs";

const PsychologistIP = ({ patientData, params, refreshPage }) => {
  return (
    <Fragment>
      {params?.type === "ia" || params?.type === "psychologist" ? (
        <PsychologistInitialAssessmentProvider>
          <PsychologistInitialInspection
            refreshPage={refreshPage}
            editId={patientData?.psychology_initial_assessment}
            patientData={patientData}
          />
        </PsychologistInitialAssessmentProvider>
      ) : params?.type === "review" ? (
        <PsychologistReviewProvider>
          <PsychologistReview
            reviewData={patientData?.psychology_review}
            iAssessment={patientData?.psychology_initial_assessment}
            refreshPage={refreshPage}
            patientData={patientData}
          />
        </PsychologistReviewProvider>
      ) : params?.type === "medicine" ? (
        <MedicationHistoryIP patientData={patientData} />
      ) : params?.type === "chat" ? (
        <ChatTabs patientData={patientData} />
      ) : null}
    </Fragment>
  );
};

export default PsychologistIP;
